var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('layout',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h6',{staticStyle:{"font-family":"'Prompt', sans-serif"}},[_vm._v("จำนวนชั่วโมงเรียนรวมในแต่ละช่วงเวลา")])]},proxy:true},{key:"body",fn:function(){return [_c('line-chart',{attrs:{"chartData":_vm.data,"chartOption":_vm.options,"chartHeight":150}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }